/* eslint-disable no-underscore-dangle */
import placementTestConstants from '../constants/placementTestConstants';
import userConstants from '../constants/userConstants';
import placementTestServices from '../services/placementTestServices';
import groupActions from './groupActions';

function initTest(codeId, body) {
  function request() {
    return {
      type: placementTestConstants.INIT_REQUEST,
    };
  }

  function success(test) {
    return {
      type: placementTestConstants.INIT_SUCCESS,
      test,
    };
  }

  function failure(error) {
    return {
      type: placementTestConstants.INIT_FAILURE,
      error,
    };
  }

  return (dispatch) => {
    dispatch(request());
    placementTestServices.initTest(codeId, body)
      .then(
        (test) => {
          localStorage.setItem('test', JSON.stringify(test));
          dispatch(success(test));
        },
        (error) => {
          dispatch(failure(error ? error.toString() : 'error'));
        },
      );
  };
}

const setCurrentQuestion = (currentQuestion) => {
  localStorage.setItem('currentQuestion', JSON.stringify(currentQuestion));
  return ({
    type: placementTestConstants.SET_CURRENT_QUESTION,
    currentQuestion,
  });
};

const setCurrentAnswer = (currentAnswer) => ({
  type: placementTestConstants.SET_CURRENT_ANSWER,
  currentAnswer,
});

const setMultiQuestionId = (id) => ({
  type: placementTestConstants.SET_MULTI_QUESTION_ID,
  id,
});

const pushAnswer = () => (dispatch, getState) => {
  const state = getState();
  const { currentAnswer } = state.placementTest;
  const answers = [...state.placementTest.answers, ...currentAnswer];
  localStorage.setItem('answers', JSON.stringify(answers));
  dispatch({
    type: placementTestConstants.PUSH_ANSWER,
    answers,
  });
};

const clearTest = () => {
  localStorage.removeItem('test');
  localStorage.removeItem('currentQuestion');
  localStorage.removeItem('answers');
  return (dispatch, getState) => {
    // Define test is finished in localstorage in case user refreshes the page
    const testFinishedStorage = JSON.parse(localStorage.getItem('auth'));
    Object.defineProperty(testFinishedStorage, 'testFinish', { value: true });
    localStorage.removeItem('auth');
    localStorage.setItem('auth', JSON.stringify(testFinishedStorage));

    dispatch({ type: placementTestConstants.CLEAR_TEST });
    dispatch({ type: userConstants.TEST_DONE });
    dispatch(groupActions.getGroup(getState().user.userData._id));
  };
};

const placementTestActions = {
  initTest,
  setMultiQuestionId,
  setCurrentQuestion,
  setCurrentAnswer,
  pushAnswer,
  clearTest,
};

export default placementTestActions;
